import { useTranslation } from 'react-i18next'

import { ClockCounterClockwiseIcon, WarningCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const HistoryEmptyState = ({ error }) => {
  const theme = useTheme()
  const iconProps = { size: 48, color: theme.colors.border.default }
  const { t } = useTranslation()

  const icon = error ? <WarningCircleIcon {...iconProps} /> : <ClockCounterClockwiseIcon {...iconProps} />
  const message = error
    ? t('Ha ocurrido un error al cargar el historial.')
    : t('No se han encontrado cambios en esta página.')

  return (
    <Styles.Container>
      {icon}
      <Text type="bodyMRegular" color={theme.colors.text.subtle}>
        {message}
      </Text>
    </Styles.Container>
  )
}

export default HistoryEmptyState
